import {
  vBoolean,
  vDate,
  vFallback,
  vNumber,
  vObject,
  vOptional,
  type vOutput,
  vPicklist,
} from '../validation/index.ts'
import { chatAiModels } from './ai.ts'

export const DEFAULT_AI_ALLOWANCE = 20

const chatSettingsSchema = vObject({
  model: vOptional(vPicklist(chatAiModels)),
})
const aiSettingsSchema = vObject({
  allowance: vOptional(vNumber()),
})
// Internal settings schema - for admin-only settings
export const internalAccountSettingsSchema = vObject({
  shareQuoteData: vFallback(vBoolean(), true),
  restrictNewLtlCarriers: vFallback(vBoolean(), false),
  ndaSigned: vOptional(vDate()),
  chat: vOptional(chatSettingsSchema),
  ai: vOptional(aiSettingsSchema),
})

export type InternalAccountSettings = vOutput<
  typeof internalAccountSettingsSchema
>
